

//import ActivityTitle from './ActivityTitle'
import TFReadTextModel from "./TFReadTextModel"
import SoundModel from "./SoundModel"
import Axios from "axios";
class Activity {


    constructor() {

        this.activityType = -1;

        this.TF_ACTIVITY_TYPE = 0;
        this.DRAG_DROP_PARAGRAPH_ACTIVITY_TYPE = 1
        this.DRAG_WORD_TO_IMG = 2;
        this.SORT_STORY = 3;
        this.DRAG_DROP_PARGRAPH = 4;
        this.WORD_ON_IMG = 5;
        this.COMPARE = 6
        this.CLASSIFICATION = 7
        this.CONNECT = 8;
        this.WRITE_MISSING_WORDS = 9;

        this.activityId = -1
        this.loList = [];
        this.activityIndex = -1;
        this.activityTitle = new ActivityTitle()
        this.activityTitleShareIndex = -1;
        this.activityReadTextShareIndex = -1;
        this.activitySoundShareIndex = -1;
        this.readText = new TFReadTextModel()
        this.soundModel = new SoundModel();
        this.answeredTrue = true
        this.answerExplanation = ""
        this.reminderCard = ""
        this.videoLinks = ""
        this.attemptsNo = 0;
        this.reaction = 0

        this.isSkipped = false
        //this.mainAppRef=null
        this.numOfAttempts = 1;
        this.useReminderCard = false;
    }


    initFromJson = (obj) => { }
    getAsJson = () => { }
    getJsCode = () => { }
    initSharedItems = () => { }
    getAnsweredTrue = () => { }
    resetActivity = () => { }
    getIsSkipped = () => { }


    getResRootPath = () => {
        let typeNameList = [
            { type: 1, name: "ESSAY" },
            { type: 2, name: "FILL_IN_BLANK" },
            { type: 3, name: "HOTSPOT" },
            { type: 4, name: "MATCHING" },
            { type: 5, name: "MCQ_SINGLE" },
            { type: 6, name: "MCQ_MULTIPLE" },
            { type: 7, name: "ORDERING" },
            { type: 8, name: "TRUE_FALSE" },
            { type: 9, name: "JUMBLE_WORD" },
            { type: 10, name: "PICK_FROM_LIST" },
            { type: 11, name: "DRAG_DROP" },
        ]

        let typeName = ""
        typeNameList.map(item => {
            if (item.type == this.questionType) {
                typeName = item.name
            }
        })

        return "http://s3.amazonaws.com/cdn.testengine.com/CONTENT/" + typeName ;

    }


    getPublicItemsAsJson = () => {
        let obj = {
            activityType: this.activityType,
            activityTitleShareIndex: this.activityTitleShareIndex,
            activityReadTextShareIndex: this.activityReadTextShareIndex,
            activitySoundShareIndex: this.activitySoundShareIndex,
            // activityTitleAr: this.activityTitle.activityTitleAr,
            // activityTitleEng: this.activityTitle.activityTitleEng,
            readTextObj: this.readText.getAsJson(),
            soundModel: this.soundModel.getAsJson(),
            activityTitle: this.activityTitle.getAsJson(),
            isSkipped: this.isSkipped,
            numOfAttempts: this.numOfAttempts,
            useReminderCard: this.useReminderCard
        }

        return obj
    }


    initPublicItemsFromJson = (obj) => {
        this.activityType = obj.activityType;
        this.activityTitleShareIndex = obj.activityTitleShareIndex
        this.activityReadTextShareIndex = obj.activityReadTextShareIndex;
        this.activitySoundShareIndex = obj.activitySoundShareIndex;
        // this.activityTitle.activityTitleAr = obj.activityTitleAr
        // this.activityTitle.activityTitleEng = obj.activityTitleEng
        this.readText.initFromJson(obj.readTextObj);
        this.soundModel.initFromJson(obj.soundModel);
        this.activityTitle.initFromJson(obj.activityTitle)

        this.isSkipped = obj.isSkipped;
        this.numOfAttempts = obj.numOfAttempts;
        this.useReminderCard = obj.useReminderCard;
    }


    initPublicSharedItem = (activityArr) => {

        if (this.activityTitleShareIndex != -1) {
            this.activityTitle = activityArr[this.activityTitleShareIndex].activityTitle;
        }
        if (this.activityReadTextShareIndex != -1) {
            this.readText = activityArr[this.activityReadTextShareIndex].readText;
        }

        if (this.activitySoundShareIndex != -1) {

            this.soundModel = activityArr[this.activitySoundShareIndex].soundModel;
        }
    }
    getReportAsJson = () => {
        let obj = {}
        return this.getAsJson()
    }


    initReportFromJson = (userAns) => {

    }

    initPublicItemsFromJsonTest4You = (obj) => {
        
        this.activityType = obj.activityType;
        // this.activityId = obj.activityId;

        this.activityTitle.activityTitleAr = ""
        this.activityTitle.activityTitleEng = ""
        // this.readText.enabled=false
        if (obj.readTextObj)
            this.readText.initFromJsonTest4You(obj.readTextObj);
        this.soundModel.initFromJsonTest4You(obj.soundModel);
        this.answerExplanation = obj.answerExplanation
        this.reminderCard = obj.reminderCard
        if (obj.videoLinks)
            this.videoLinks = obj.videoLinks
        this.isSkipped = obj.isSkipped
    }

    
    getLOList = (callback) => {
        let AggregatedList = ""
        this.loList.map((item) => {
            if (AggregatedList == "")
                AggregatedList = item.lo;
            else
                AggregatedList += "," + item.lo;
        })

        let catId = this.loList[0].qTopicId
        console.log('http://testcards.ga/public/api/reminder-card/get/' + catId + '/' + AggregatedList)
        Axios({
            method: 'get',
            url: 'https://testcards.ga/public/api/reminder-card/get/' + catId + '/' + AggregatedList,
            headers: {
                "Content-type": 'application/x-www-form-urlencoded'
            }
        }).then(function (response) {

            callback(response);
        })
            .catch(function (error) {
                console.log(error);
            });

    }
}



class ActivityTitle {

    constructor() {
        this.activityTitleAr = "";
        this.activityTitleEng = "";
        this.selectedStyle = null;

    }

    getAsJson = () => {
        let obj = {
            activityTitleAr: this.activityTitleAr,
            activityTitleEng: this.activityTitleEng,
            selectedStyle: this.selectedStyle
        }

        return obj;
    }


    getJsCode = () => {
        let obj = {
            activityTitleAr: this.activityTitleAr,
            activityTitleEng: this.activityTitleEng
        }

        return obj;
    }


    initFromJson = (obj) => {

        this.activityTitleAr = obj.activityTitleAr
        this.activityTitleEng = obj.activityTitleEng
        this.selectedStyle = obj.selectedStyle
    }

}

export default Activity